import { Client } from '../index';

const apiPrefix = 'portal';

export type SchemeOptionItem = {
  code: string;
  name: string;
};

export type SchemeOptionsResult = {
  industryList: SchemeOptionItem[];
  productList: SchemeOptionItem[];
};

export type SchemeManageQuery = {
  keyword?: string;
  industryCode?: string;
  productCategoryCode?: string;
  pageNum: number;
  pageSize: number;
};

export type SchemeManageItem = {
  sn: string;
  title: string;
  industryCode: string;
  industryName: string;
  productCategoryCode: string;
  productCategoryName: string;
  fileName: string;
  fileUrl: string;
  fileType: string;
  fileSize: number;
  status: number;
  createdAt: string;
};

export type SchemeManagePageResult = {
  records: SchemeManageItem[];
  total: number;
};

export type SchemeManageCreatePayload = {
  title: string;
  industryCode: string;
  productCategoryCode: string;
  fileName: string;
  fileUrl: string;
  fileType: string;
  fileSize: number;
};

export type SchemeManageUpdatePayload = SchemeManageCreatePayload & {
  sn: string;
};

export const GetSchemeManageOptions = async (): Promise<SchemeOptionsResult | null> => {
  return await Client.get<SchemeOptionsResult>({
    url: apiPrefix + '/scheme/manage/options',
  });
};

export const GetSchemeManagePage = async (data: SchemeManageQuery): Promise<SchemeManagePageResult | null> => {
  return await Client.get<SchemeManagePageResult>({
    url: apiPrefix + '/scheme/manage/page',
    data,
  });
};

export const CreateSchemeManage = async (data: SchemeManageCreatePayload): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/scheme/manage/create',
    data,
  });
};

export const UpdateSchemeManage = async (data: SchemeManageUpdatePayload): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/scheme/manage/update',
    data,
  });
};

export const GetObsTokenForScheme = async (data: { suffix: string; prefix?: string }): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/web/obs/token',
    data,
  });
};
